// import Events from '@utilities/events'
import detectOs from '@utilities/detect-os';

const LOADED_CLASS = 'is--loaded'
const AGENT_IOS_CLASS = 'is--ios'
const AGENT_ANDROID_CLASS = 'is--android'
class Page {
  constructor(element) {
    this.page = element

    this.init()
    this.setEnvironment()
  }

  init() {
      this.page.classList.add(LOADED_CLASS)
  }

  setEnvironment() {
    if (detectOs.isIos()) {
      this.page.classList.add(AGENT_IOS_CLASS)
    } else if (detectOs.isAndroid()) {
      this.page.classList.add(AGENT_ANDROID_CLASS)
    }
  }
}

export default Page;
